import { ContentLayout } from "@/components/Layout";
import { Authorization, ROLES } from "@/libs/authorization";
import { FriendScreen } from "../components";
import { RecipientHeader } from "../components/chat";
import usePermission from "@/hooks/usePermission";

export const Friends = () => {
  const { showFriend } = usePermission();

  return (
    <ContentLayout title="Friends" header={<RecipientHeader />} showBackBtn>
      <div className="bg-white flex mb-6 rounded-2xl flex-col dark:bg-slate-900/70">
        <div className="flex-1">
          <Authorization
            forbiddenFallback={<div>Only User can view this.</div>}
            allowedRoles={[ROLES.USER]}
            policyCheck={showFriend}
          >
            <FriendScreen />
          </Authorization>
        </div>
      </div>
    </ContentLayout>
  );
};
